var _rect, _g, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeMyAiLogoExactRecreation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 300,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(175, 50) scale(0.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110,30 C150,10 190,30 200,70 C210,100 190,140 150,150 C110,160 60,140 50,100 C40,60 70,30 110,30 Z",
    fill: "none",
    stroke: "#4361EE",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,50 L140,50 L140,130 L100,130 Z",
    fill: "none",
    stroke: "#4361EE",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,70 L140,70",
    fill: "none",
    stroke: "#4361EE",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,90 L140,90",
    fill: "none",
    stroke: "#4361EE",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,110 L140,110",
    fill: "none",
    stroke: "#4361EE",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 50,
    r: 6,
    fill: "#7209B7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 40,
    r: 6,
    fill: "#7209B7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 50,
    r: 6,
    fill: "#7209B7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 90,
    r: 6,
    fill: "#7209B7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 130,
    r: 6,
    fill: "#7209B7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 140,
    r: 6,
    fill: "#7209B7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 130,
    r: 6,
    fill: "#7209B7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 90,
    r: 6,
    fill: "#7209B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,50 L120,40 L160,50 L180,90 L160,130 L120,140 L80,130 L60,90 L80,50",
    fill: "none",
    stroke: "#7209B7",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,50 L120,140",
    fill: "none",
    stroke: "#7209B7",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,50 L80,130",
    fill: "none",
    stroke: "#7209B7",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,40 L120,140",
    fill: "none",
    stroke: "#7209B7",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 90,
    r: 12,
    fill: "#00F5D4",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "12;18;12",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.7;0.3;0.7",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#00F5D4",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("animateMotion", {
    path: "M80,50 L120,40 L160,50 L180,90 L160,130 L120,140 L80,130 L60,90 L80,50",
    dur: "4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#00F5D4",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("animateMotion", {
    path: "M80,50 L120,40 L160,50 L180,90 L160,130 L120,140 L80,130 L60,90 L80,50",
    dur: "4s",
    repeatCount: "indefinite",
    begin: "2s"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 170,
    fontFamily: "Montserrat, Arial, sans-serif",
    fontSize: 68,
    fontWeight: 900,
    textAnchor: "middle",
    fill: "#4361EE"
  }, "CodeMyAI")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 215,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16,
    fontWeight: 600,
    textAnchor: "middle",
    letterSpacing: 5,
    fill: "#7209B7"
  }, "F R E E - Y O U R - T I M E  !")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeMyAiLogoExactRecreation);
export default __webpack_public_path__ + "static/media/CodeMyAI Logo Exact Recreation.0cd7e4a4112ba050d07aebb85e172208.svg";
export { ForwardRef as ReactComponent };